export const objectManagerArticle = {
    id: 'object-manager',
    title: 'Менеджер объектов: основы',
    navTitle: 'МО: основы',
    category: 'Режим Данные',
    requiredModule: null,
    gif: null,
    summary: 'Интерактивный реестр всех объектов карты с быстрым поиском, управлением видимостью и мгновенным переходом к объекту.',
    markdown: `
> **Менеджер объектов** — это интерактивная картотека и каталог всех элементов вашего проекта. Вместо того чтобы выискивать нужный участок или дом на огромной карте вручную, вы открываете удобный список, где всё структурировано и доступно за секунду.

---

## 1. Главные возможности

:::grid cols=2
:::card icon="cursor" title="Двусторонняя связь с картой"
* **Клик по строке в списке:** карта плавно подлетает к выбранному объекту, выделяет его и открывает паспорт.
* **Клик по объекту на карте:** список в менеджере сам прокручивается к нужной карточке и подсвечивает её.
:::

:::card icon="sliders" title="Умный поиск и видимость"
* **Мгновенный поиск:** фильтрует список на лету по названию, кадастровому номеру или ID.
* **Тумблеры видимости:** позволяют в 1 клик скрыть или показать любой объект прямо из списка.
:::
:::

---

## 2. Как устроен список объектов

Панель открывается кнопкой **«Менеджер объектов»** в режиме *«Данные»* и располагается слева:

![Менеджер объектов в действии](/gifs/tools/object-manager.gif)

:::grid cols=2
:::card icon="square" title="Анатомия карточки объекта"
Каждая строка списка содержит всю ключевую информацию:
* **Иконка типа:** обозначает участок, дом, дорогу или метку и окрашена в фирменный цвет категории из легенды.
* **Название и номер:** отображает присвоенное имя и кадастровый номер (или системный ID).
* **Слайдер-тумблер:** быстрый переключатель показа/скрытия объекта на карте.
:::

:::card icon="layers" title="Сортировка и память положения"
* **Свежие объекты — сверху:** новые добавленные участки и строения сразу появляются вверху списка.
* **Память скролла:** если вы закроете менеджер объектов и вернётесь к нему позже, список останется на той же позиции, где вы остановились.
:::
:::

---

## 3. Быстрый поиск и массовое управление показом

:::grid cols=2
:::card icon="edit" title="Строка быстрого поиска"
В верхней части панели введите любую часть текста:
* Кадастровый номер (например, \`66:06:4501001:123\`);
* Название участка или улицы;
* Имя владельца или ключевое слово из описания.
Список отфильтруется моментально по мере ввода букв.
:::

:::card icon="view" title="Кнопки массовой видимости"
В нижней панели менеджера отображается точный счетчик найденных объектов (*«Найдено: 15»*) и две кнопки:
* ➕ **«Показать»** — включает отображение всех найденных объектов на карте.
* ➖ **«Скрыть»** — временно прячет найденные объекты, чтобы очистить обзор.
:::
:::

:::tip Влияет ли скрытие на публичную карту для пользователей?
* **Это локальное скрытие только для вас (администратора):** переключение тумблера скрывает объект исключительно на вашем рабочем экране и сохраняется в вашем браузере.
* **На публичной карте для клиентов ничего не пропадает:** пользователи сайта по-прежнему видят все объекты и управляют их показом самостоятельно через виджет легенды.
* **Зачем это нужно:** чтобы вы могли спокойно разгрузить свой экран от лишних деталей во время черчения, проведения замеров или подготовки индивидуального макета к печати.
:::
`
};
